import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { DeshabilitarAccesoPersonalResult } from 'src/app/models/acceso/DeshabilitarAccesoPersonalResult';
import { DeshabilitarAccesosBatchModel } from 'src/app/models/acceso/DeshabilitarAccesosBatchModel';
import { FilterDeshabilitarAccesoPersonalModel } from 'src/app/models/acceso/FilterDeshabilitarAccesoPersonalModel';
import { VigilanciaAccesoPersonalResult } from 'src/app/models/acceso/VigilanciaAccesoPersonalResult';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IDeshabilitarAccesoPersonalResult } from 'src/app/models/interfaces/accesos/IDeshabilitarAccesoPersonalResult';
import { IFilterDeshabilitarAccesoPersonalModel } from 'src/app/models/interfaces/accesos/IFilterDeshabilitarAccesoPersonalModel';
import { IVigilanciaAccesoPersonalResult } from 'src/app/models/interfaces/accesos/IVigilanciaAccesoPersonalResult';
import { AccesoPersonaService } from 'src/app/services/acceso-personal/acceso-persona.service';
import { DeshabilitarAccesosPersonalDialogComponent } from '../deshabilitar-accesos-personal-dialog/deshabilitar-accesos-personal-dialog.component';
import { MatTabGroup } from '@angular/material/tabs';
import { ReestablecerAccesosPersonalDialogComponent } from '../reestablecer-accesos-personal-dialog/reestablecer-accesos-personal-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SedeService } from 'src/app/services/sede/sede.service';

@Component({
  selector: 'app-deshabilitar-accesos-personal',
  templateUrl: './deshabilitar-accesos-personal.component.html',
  styleUrls: ['./deshabilitar-accesos-personal.component.css']
})
export class DeshabilitarAccesosPersonalComponent implements OnInit {
  modelFilter: IFilterDeshabilitarAccesoPersonalModel;
  modelListaAccesoPersonal: IDeshabilitarAccesoPersonalResult[];
  modelListaReestablecerAcceso: IDeshabilitarAccesoPersonalResult[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  listaSedes: ISedeModel[]= new Array<SedeModel>();
  resultsLength = 0;
  currentPage = 0;
  resultsReestablecerLength = 0;
  currentReestablecerPage = 0;

  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild('paginatorReestablecer') paginatorReestablecer!: MatPaginator;


  @ViewChild('tabGroup') tabGroup!: MatTabGroup;

  displayedColumns: string[] = [
    'codigo',
    'compania',
    'sede',
    'trabajador',
    'nroDocumentoIdentidad',
    'contratista',
    'fechaAprobacion',
    'estado',
    'fechaInicio',
    'fechaFin',
    'acciones',
  ];

  constructor(
    private sedeService: SedeService,
    private accesoPersonalService: AccesoPersonaService,
    public dialog: MatDialog,
    private storage: StorageService
  ) {
    this.modelFilter = new FilterDeshabilitarAccesoPersonalModel();
    //No se asignan fechas para la bandeja
    //this.modelFilter.fechaInicioServicio = this.addDays(new Date(), -14);
    //this.modelFilter.fechaFinServicio = new Date();
    this.modelListaAccesoPersonal = new Array<DeshabilitarAccesoPersonalResult>();
    this.modelListaReestablecerAcceso = new Array<DeshabilitarAccesoPersonalResult>();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.companiaChanged();
    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }

  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  search(): void {
    //alert(this.tabGroup.selectedIndex)
    //this.paginator.pageIndex = 0;
    this.modelFilter.page = 1;
    // this.model.pageSize = this.paginator.pageSize;
    this.accesoPersonalService
      .getListDeshabilitar(this.modelFilter)
      .subscribe((data: SearchResultModel<IDeshabilitarAccesoPersonalResult[]>) => {
        this.modelListaAccesoPersonal = data.items;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
    this.accesoPersonalService
      .getListReestablecer(this.modelFilter)
      .subscribe((data: SearchResultModel<IDeshabilitarAccesoPersonalResult[]>) => {
        this.modelListaReestablecerAcceso = data.items;
        this.resultsReestablecerLength = data.total;
        this.currentReestablecerPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.accesoPersonalService
      .getListDeshabilitar(this.modelFilter)
      .subscribe(
        (data: SearchResultModel<IDeshabilitarAccesoPersonalResult[]>) => {
          this.modelListaAccesoPersonal = data.items;
          this.resultsLength = data.total;
        }
      );
  }

  getPaginatorReestablecerData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.accesoPersonalService
      .getListReestablecer(this.modelFilter)
      .subscribe(
        (data: SearchResultModel<IDeshabilitarAccesoPersonalResult[]>) => {
          this.modelListaReestablecerAcceso = data.items;
          this.resultsReestablecerLength = data.total;
        }
      );
  }

  deshabilitar() {
    let deshabilitarAccesosBatch = new DeshabilitarAccesosBatchModel();
    deshabilitarAccesosBatch.listaIdAccesosPersonales = this.modelListaAccesoPersonal.filter(p => p.deshabilitar).map(a => a.idAccesoPersonal);
    const dialogRef = this.dialog.open(DeshabilitarAccesosPersonalDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: deshabilitarAccesosBatch
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.search();
    });
  }

  reestablecer() {
    let deshabilitarAccesosBatch = new DeshabilitarAccesosBatchModel();
    deshabilitarAccesosBatch.listaIdAccesosPersonales = this.modelListaReestablecerAcceso.filter(p => p.deshabilitar).map(a => a.idAccesoPersonal);
    const dialogRef = this.dialog.open(ReestablecerAccesosPersonalDialogComponent, {
      width: '500px',
      // data: { name: this.name, animal: this.animal}
      data: deshabilitarAccesosBatch
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.search();
    });
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  esInvalido(): boolean {
    return this.modelListaAccesoPersonal.filter(p => p.deshabilitar).length == 0;
  }

  esInvalidoReestablecer(): boolean {
    return this.modelListaReestablecerAcceso.filter(p => p.deshabilitar).length == 0;
  }

  export() {
    if (this.tabGroup.selectedIndex == 0) {
      //this.modelFilter.page = 1;
      this.accesoPersonalService.getListDeshabilitarToExport(this.modelFilter).subscribe(
        (data) => {
          let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
          const url = window.URL.createObjectURL(blob);
          fileSaver.saveAs(blob, `accesos-por-deshabilitar-${Date.now()}.xlsx`);
        },
        (error) => {
        }
      );
    }
    else {
      this.accesoPersonalService.getListReestablecerToExport(this.modelFilter).subscribe(
        (data) => {
          let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
          const url = window.URL.createObjectURL(blob);
          fileSaver.saveAs(blob, `accesos-por-reestablecer-${Date.now()}.xlsx`);
        },
        (error) => {
        }
      );
    }
  }
}
